// Instead of relying on the `@iabtechlabtcf/core` package, we use our own types
// as we made the experience that TCF does not update the package regularly and keep the
// types streamlined with the documentation / GVL specification.
var ETcfGvlVersion = /*#__PURE__*/ function(ETcfGvlVersion) {
    ETcfGvlVersion["v2"] = "v2";
    ETcfGvlVersion["v3"] = "v3";
    return ETcfGvlVersion;
}(ETcfGvlVersion || {});
var ETcfGvlDisclosureType = /*#__PURE__*/ function(ETcfGvlDisclosureType) {
    ETcfGvlDisclosureType["Cookie"] = "cookie";
    ETcfGvlDisclosureType["Web"] = "web";
    ETcfGvlDisclosureType["App"] = "app";
    return ETcfGvlDisclosureType;
}(ETcfGvlDisclosureType || {});
var ETcfGvlLanguage = /*#__PURE__*/ function(ETcfGvlLanguage) {
    ETcfGvlLanguage["Bulgarian"] = "bg";
    ETcfGvlLanguage["Catalan"] = "ca";
    ETcfGvlLanguage["Czech"] = "cs";
    ETcfGvlLanguage["Danish"] = "da";
    ETcfGvlLanguage["German"] = "de";
    ETcfGvlLanguage["Greek"] = "el";
    ETcfGvlLanguage["Spanish"] = "es";
    ETcfGvlLanguage["Estonian"] = "et";
    ETcfGvlLanguage["Basque"] = "eus";
    ETcfGvlLanguage["Finnish"] = "fi";
    ETcfGvlLanguage["French"] = "fr";
    ETcfGvlLanguage["Galician"] = "gl";
    ETcfGvlLanguage["Croatian"] = "hr";
    ETcfGvlLanguage["Hungarian"] = "hu";
    ETcfGvlLanguage["Italian"] = "it";
    ETcfGvlLanguage["Japanese"] = "ja";
    ETcfGvlLanguage["Lithuanian"] = "lt";
    ETcfGvlLanguage["Latvian"] = "lv";
    ETcfGvlLanguage["Maltese"] = "mt";
    ETcfGvlLanguage["Dutch"] = "nl";
    ETcfGvlLanguage["Norwegian"] = "no";
    ETcfGvlLanguage["Polish"] = "pl";
    ETcfGvlLanguage["Portuguese"] = "pt";
    ETcfGvlLanguage["Romanian"] = "ro";
    ETcfGvlLanguage["SerbianCyrillic"] = "sr-Cyrl";
    ETcfGvlLanguage["SerbianLatin"] = "sr-Latn";
    ETcfGvlLanguage["Russian"] = "ru";
    ETcfGvlLanguage["Slovak"] = "sk";
    ETcfGvlLanguage["Slovenian"] = "sl";
    ETcfGvlLanguage["Swedish"] = "sv";
    ETcfGvlLanguage["Turkish"] = "tr";
    ETcfGvlLanguage["Chinese"] = "zh";
    return ETcfGvlLanguage;
}(ETcfGvlLanguage || {});
export { ETcfGvlVersion, ETcfGvlLanguage, ETcfGvlDisclosureType };
